import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ConnectionDetailsPage from "./pages/ConnectionDetailsPage";
import LogoutPage from "./pages/LogoutPage";

function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/connection-details" element={<ConnectionDetailsPage />} />
        <Route path="/logout" element={<LogoutPage />} />
      </Routes>
    </div>
  );
}

export default App;
